onmessage = async event => {
  const response = await fetch(event.data.url, {
    method: 'post',
    body: JSON.stringify(event.data.data),
    headers: event.data.headers
  })

  if (!response.ok) {
    postMessage({
      status: response.status,
      data: event.data.data,
      url: event.data.url
    })
  }
}
